import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';
import getPinnedTooltipCoordinate from 'utils/getPinnedTooltipCoordinate';
 
export const SYSTEMICSEGMENT_LAYER_ID = 'systemicSegmentLayer';
 
export const CATEGORY_COLORS = {
  'City Line': [241, 100, 119],
};
 
const layerConfig = {
  title: 'Systemic Score Segments',
};
 
function SystemicSegmentLayer() {
  const dispatch = useDispatch();
  const { systemicSegmentLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, systemicSegmentLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const {pinnedTooltip, setPinnedTooltip} = useAppState();
  const pointLineWidth = viewState.zoom >= 7 ? 7 : 5;
  if (systemicSegmentLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SYSTEMICSEGMENT_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: systemicSegmentLayer.visible,
      opacity: systemicSegmentLayer.opacity,
 
       getLineColor: colorBins({
        attr: 'Systemic_Score',
        domain: [2, 4, 6, 8, 9],
        colors: [
          [145, 53, 125, 51],
          [145, 53, 125, 102],
          [145, 53, 125, 153],
          [145, 53, 125, 204],
          [145, 53, 125, 255],
        ],
      }),
    lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
 
/*       getDashArray: [3, 1.5],
      dashJustified: true,
      dashGapPickable: true,
      extensions: [new PathStyleExtension({ dash: true })], */
 
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SYSTEMICSEGMENT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },
 
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['hccl_name'],
            }),
          };
        }
      },
      onClick: (info) => {
        if (info?.object) {
          const html = htmlForFeature({ feature: info.object });
          if (pinnedTooltip?.html === html) {
            setPinnedTooltip(null);
          } else {
            setPinnedTooltip({
              html,
               postMileInfo: info.object.properties,
              coordinate: getPinnedTooltipCoordinate(info),
            });
          }
        }
      },

    });
  }
}
 
export default SystemicSegmentLayer;
 